import { faCartShopping, faMap, faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import type { IUseMods } from "../components/views/mods";
import type { SteamWorkshopItem } from "../graphql";
import { commonMenuItems } from "./common";
import csgoProfile from "./csgo";
import defaultProfile, { asyncRoute } from "./default";
import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(
    commonMenuItems.console,
    new MenuItem(
      "workshop",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/csgo/workshop/Workshop.vue")),
      [
        {
          route: "manage",
          component: asyncRoute(() => import("../components/views/mods/manage/ModsManage.vue")),
        },
      ],
    ),
    new MenuItem(
      "mapgroups",
      faMap,
      asyncRoute(() => import("../components/views/config/csgo/map_groups/MapGroups.vue")),
    ),
  );
  menu[1].items.push(
    new MenuItem(
      "tebex",
      faCartShopping,
      asyncRoute(() => import("../components/views/Tebex.vue")),
    ),
  );
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "SteamGslt" },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "Cs2MapSelection" },
  { component: "ConfSection", props: { name: "bot" } },
  { component: "ConfSection", props: { name: "gotv" } },
  { component: "ConfSection", props: { name: "casual_misc" } },
  { component: "ConfSection", props: { name: "casual_money" } },
  { component: "ConfSection", props: { name: "competitive_misc" } },
  { component: "ConfSection", props: { name: "competitive_money" } },
  { component: "ConfSection", props: { name: "deathmatch_misc" } },
];

export default (_ctx: ProfileCtx): GameProfile<SteamWorkshopItem, IUseMods<SteamWorkshopItem>> => ({
  ...csgoProfile(),
  menu: createMenu(),
  configSections,
});
